import { render } from "./sidebarHeader.vue?vue&type=template&id=bf51d164&scoped=true&ts=true"
import script from "./sidebarHeader.vue?vue&type=script&lang=ts"
export * from "./sidebarHeader.vue?vue&type=script&lang=ts"

import "./sidebarHeader.vue?vue&type=style&index=0&id=bf51d164&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf51d164"]])

export default __exports__